import Firebase from 'firebase';
import ReactFireMixin from 'reactfire';
import Lazy from 'lazy.js';
import process from 'process';

// TODO(tirsen): We should probably do this using a context instead.
const albertEnv = typeof ALBERT_ENV === 'undefined' ? process.env.ALBERT_ENV : ALBERT_ENV;

const firebaseUrl = `https://albert-${albertEnv}.firebaseio.com`;
console.log(`Connecting to ${firebaseUrl}`);
export const firebaseRoot = new Firebase(firebaseUrl);

// Map over a Firebase DataSnapshot.
export function snapshotMap(snapshot, iterator) {
    var result = [];
    var i = 0;
    snapshot.forEach(child => {
        result.push(iterator(child, i++));
    });
    return result;
}

// Each call to the iterator should return an array, all elements are concatenated to the resulting array.
// So it's just a combination of map and flatten wrapped up into a single utility function.
// The iterator can also return null or anything falsy in which case nothing is concatenated onto the array.
export function snapshotFlatMap(snapshot, iterator) {
    var result = [];
    var i = 0;
    snapshot.forEach(child => {
        var items = iterator(child, i++);
        if (items) {
            result.push(...items);
        }
    });
    return result;
}

// Transform a DataSnapshot into an array of DataSnapshots. Preserves the order defined by Firebase.
export function snapshotToArray(snapshot, iterator) {
    return snapshotMap(snapshot, e => e);
}

// Transform a DataSnapshot into an array of values. Preserves the order defined by Firebase.
export function snapshotToDeepArray(snapshot, iterator) {
    return snapshotMap(snapshot, e => e.val());
}

// Use Lazy over a Firebase DataSnapshot.
Lazy.Sequence.define("dataSnapshot", {
    init() {
    },

    each(fn) {
        return this.parent.source.forEach(fn);
    }
});



/** WEBPACK FOOTER **
 ** ./src/utils/firebase-utils.js
 **/